export default "__VITE_ASSET__akqG2P0E__"